export type ChatScrollFollowState = {
  isUserNearBottom: boolean;
  shouldKeepFollowingBottom: boolean;
};

export const FOLLOWING_BOTTOM_STATE: ChatScrollFollowState = {
  isUserNearBottom: true,
  shouldKeepFollowingBottom: true,
};

export function followStateAfterScroll({
  state,
  stableIsLoading,
  heightGrew,
  userScrolledUp,
  isNearBottom,
  isInitialScrollPending,
}: {
  state: ChatScrollFollowState;
  stableIsLoading: boolean;
  heightGrew: boolean;
  userScrolledUp: boolean;
  isNearBottom: boolean;
  isInitialScrollPending: boolean;
}): ChatScrollFollowState {
  if (stableIsLoading && heightGrew && !userScrolledUp) {
    return { ...state, isUserNearBottom: true };
  }

  if (state.shouldKeepFollowingBottom && !userScrolledUp) {
    return FOLLOWING_BOTTOM_STATE;
  }

  if (isNearBottom || isInitialScrollPending) {
    return { ...state, isUserNearBottom: isNearBottom };
  }

  return { isUserNearBottom: false, shouldKeepFollowingBottom: false };
}

export function shouldFollowBottom({
  state,
  stableIsLoading,
  loadingJustEnded,
  contentChanged,
}: {
  state: ChatScrollFollowState;
  stableIsLoading: boolean;
  loadingJustEnded: boolean;
  contentChanged: boolean;
}): boolean {
  return (
    state.isUserNearBottom &&
    (stableIsLoading ||
      loadingJustEnded ||
      (state.shouldKeepFollowingBottom && contentChanged))
  );
}
